// extracted by mini-css-extract-plugin
export var root = "xnmxJG9G0wk5Hg93QgYq";